import { displayGenericErrorToaster } from '@/api/helpers/helpers';

/**
 * Helper to copy data
 * @param {string} dataToCopy - string to copy
 * @returns {Promise} - promise with success or failure
 */
export function copyData(dataToCopy) {
  return new Promise((resolve, reject) => {
    navigator.clipboard
      .writeText(dataToCopy || '')
      .then(() => {
        resolve('success');
      })
      .catch(e => {
        displayGenericErrorToaster();
        reject(e);
      });
  });
}
